import { Component, OnInit, OnDestroy } from "@angular/core";
import { ExitSurveyService } from "../services/exit-survey.service";
import { PageParamStorageService } from "../../core/services/page-param-storage.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { RouteHelperService } from "../../core/services/route-helper.service";
import { ExitSurvey, PageParams, QueryParams, SelectPickerEntry, SortParams } from "../exit-survey.interfaces";
const moment = require("moment");
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-exit-survey-list",
  templateUrl: "./exit-survey-list.component.html",
  styleUrls: ["./exit-survey-list.component.css"],
})
export class ExitSurveyListComponent implements OnInit, OnDestroy {
  public loading: boolean;
  public exitSurveyVersions: SelectPickerEntry[] = [];
  public items: ExitSurvey[] = [];
  public totalItems: number;
  public pageParams: QueryParams = {};
  public filterFields: string[] = [
    'email',
    'from',
    'until',
    'exitSurveyVersion',
  ];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routeHelperService: RouteHelperService,
    private pageParamStorageService: PageParamStorageService,
    private exitSurveyService: ExitSurveyService,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle(`Exit Surveys | CODE Hospitality CMS`);
    alertify.logPosition("bottom right");

    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        if (Object.keys(params).length === 0 && this.pageParamStorageService.pageParams) {
          params = this.pageParamStorageService.pageParams;
          this.queryParams(params);
        }

        this.pageParams = this.routeHelperService.getValidatedParams(params);
        this.loadItems(this.pageParams);
        this.pageParamStorageService.pageParams = this.pageParams;
      });

    this.loadVersions();
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  public versionChanged(event) {
    const value = event.target.value;
    this.filterSearch({
      exitSurveyVersion: value,
    });
  }

  public fromChanged(date: string) {
    let from = '';
    if (date) {
      from = moment(date).startOf('month').format('YYYY-MM-DD');
    }
    if (from == '') {
      this.pageParams.from = null;
    }
    this.filterSearch({
      from,
    });
  }

  public untilChanged(date: string) {
    let until = '';
    if (date) {
      until = moment(date).endOf('month').format('YYYY-MM-DD');
    }
    if (until == '') {
      this.pageParams.until = null;
    }
    this.filterSearch({
      until,
    });
  }

  public emailChanged(email: string) {
    this.filterSearch({
      email,
    });
  }

  public clearFilters() {
    this.pageParams = { pageSize: this.pageParams.pageSize };
    this.pageParamStorageService.pageParams = this.pageParams;
    this.filterSearch({}, this.filterFields);
  }

  private filterSearch(data: QueryParams, except: string[] = []) {
    const result = {};
    for (const i of this.filterFields) {
      result[i] = null != data[i] ? data[i] : this.pageParams[i];
    }
    for (const i of except) {
      delete result[i];
    }

    this.router.navigate([], { queryParams: result });
  }

  public onSort(data: SortParams) {
    this.queryParams({
      sortBy: data.column,
      sortOrder: data.order,
    });
  }

  public onPageChanged(page: PageParams) {
    this.queryParams({
      pageNumber: page.pageNumber,
      pageSize: page.pageSize,
    });
  }

  private queryParams(params: QueryParams) {
    const result = this.routeHelperService.queryParams(params, this.pageParams);
    this.router.navigate([], { queryParams: result });
  }

  private loadItems(params: QueryParams) {
    this.loading = true;
    this.exitSurveyService.getAllSurveys(params)
      .subscribe(
      result => {
        const data = result.json();
        this.items = data.items;
        this.totalItems = data.totalItems;
        this.loading = false;
      },
      error => {
        alertify.error(error)
        this.loading = false;
      })
  }

  private loadVersions() {
    this.exitSurveyService.getSurveryVersions()
      .subscribe(
      result => {
        const data = result.json();
        this.exitSurveyVersions = data.map((i: number) => {
          return {
            value: i,
            name: `Version ${i}`,
          }
        })
        this.exitSurveyVersions.unshift({
          value: null,
          name: 'All versions',
        })
      },
      error => {
        alertify.error(error)
      });
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/exit-survey-list/exit-survey-list.component.ts